// „Passwort vergessen“ (Login, Anmeldung im neuen Design, App): Fehler von `send-password-setup-email` lesbar machen.
//
// Die Function antwortet bei einer Adresse ohne Konto mit 500 und
// `{ error: "Failed to generate password setup link", details: "User with this email not found" }`. Im Browser stand
// dann nur „Edge Function returned a non-2xx status code“ (31.10.2026, dreimal in 48 Stunden; zum Start kommen viele
// Rückkehrer:innen mit einer anderen Adresse). Keine Importe: Login.tsx und die wörtlichen Kopien nehmen dieselbe Datei.

export interface PasswortMailFehler {
  titel: string;
  text: string;
}

export const KEIN_KONTO: PasswortMailFehler = {
  titel: "Zu dieser Adresse gibt es kein Konto",
  text: "Prüf bitte die Schreibweise. Vielleicht hast du dich mit einer anderen E-Mail-Adresse angemeldet. Dann hilft dir info@musikonzept.de weiter.",
};

export const MAIL_NICHT_VERSCHICKT: PasswortMailFehler = {
  titel: "Die Mail konnte gerade nicht verschickt werden",
  text: "Bitte versuch es gleich noch einmal. Klappt es weiter nicht, schreib uns an info@musikonzept.de.",
};

/** Was im Hinweis steht, wenn `supabase.functions.invoke("send-password-setup-email")` einen Fehler liefert. */
export async function passwortMailFehler(fehler: unknown): Promise<PasswortMailFehler> {
  const kontext = (fehler as { context?: unknown } | null)?.context;
  if (kontext instanceof Response) {
    try {
      // `clone()`, damit ein späterer Leser den Körper noch bekommt.
      const koerper = (await kontext.clone().json()) as { error?: unknown; details?: unknown } | null;
      const roh = `${String(koerper?.details ?? "")} ${String(koerper?.error ?? "")}`;
      if (/not found|user_not_found/i.test(roh)) return KEIN_KONTO;
    } catch {
      // Kein JSON: dann bleibt der allgemeine Satz.
    }
  }
  return MAIL_NICHT_VERSCHICKT;
}
